import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";
import enPages from "../../../public/locales/en/pages.json";

export interface FaqItem {
  q: string;
  a: string;
}

/** English source of truth, used for the FAQPage JSON-LD (crawler-facing). */
export const faqs: FaqItem[] = ((enPages as { faq?: { items?: FaqItem[] } }).faq?.items ?? []);


export function FaqSection() {
  const { t } = useTranslation("pages");
  const faqs = t("faq.items", { returnObjects: true }) as FaqItem[];

  return (
    <section id="faq" className="scroll-mt-24 border-y border-border bg-secondary/40 py-20">
      <div className="mx-auto max-w-3xl px-5">
        <h2 className="text-3xl text-primary sm:text-4xl">{t("faq.title")}</h2>
        <p className="mt-3 text-muted-foreground">
          {t("faq.subtitle")}
        </p>

        <Accordion type="single" collapsible className="mt-8">
          {faqs.map((f) => (
            <AccordionItem key={f.q} value={f.q}>
              <AccordionTrigger className="text-left text-base text-primary hover:text-accent">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
